/**
 * Created by kevinqueeney on 08/09/2015.
 */
angular.module('qkr.inventory').factory('variantHelperService', ['variantCoefficientHelperService', 'utils', function(variantCoefficientHelperService, utils) {
    const variantSetOptionColours = ['blue', 'purple', 'orange'];

    const getVariantDetailForVariantType = function(variant, variantType) {
        for (let i = 0; i < variant.variantDetails.length; i++) {
            const variantDetail = variant.variantDetails[i];
            if (variantDetail.variantLabel == variantType) {
                return variantDetail;
            }
        }
    };

    const variantSetOptionExists = function(variantSetSummary, variantSetOptionValue) {
        for (let i = 0; i < variantSetSummary.options.length; i++) {
            const variantSetSummaryOption = variantSetSummary.options[i];

            if (variantSetSummaryOption.optionValue == variantSetOptionValue) {
                return true;
            }
        }

        return false;
    };

    const getVariantSetSummaryForVariantType = function(variantSetSummaries, variantType) {
        for (let i = 0; i < variantSetSummaries.length; i++) {
            const variantSetSummary = variantSetSummaries[i];
            if (variantSetSummary.type == variantType) {
                return variantSetSummary;
            }
        }

        return null;
    };

    const getIndexOfVariantSetSummaryForVariantType = function(variantSetSummaries, variantType) {
        for (let index = 0; index < variantSetSummaries.length; index++) {
            const variantSetSummary = variantSetSummaries[index];

            if (variantSetSummary.type == variantType) {
                return index;
            }
        }

        return -1;
    };

    const getVariantSetSummaryOptionForOptionValue = function(variantSetSummary, optionValue) {
        for (let i = 0; i < variantSetSummary.options.length; i++) {
            const variantSetSummaryOption = variantSetSummary.options[i];
            if (variantSetSummaryOption.optionValue == optionValue) {
                return variantSetSummaryOption;
            }
        }

        return null;
    };

    const getIndexOfVariantSetSummaryOptionForOptionValue = function(variantSetSummary, optionValue) {
        for (let index = 0; index < variantSetSummary.options.length; index++) {
            const variantSetSummaryOption = variantSetSummary.options[index];

            if (variantSetSummaryOption.optionValue == optionValue) {
                return index;
            }
        }

        return -1;
    };

    const variantExistsWithVariantSetOption = function(variantInfrastructure, variantSetSummary, variantSetSummaryOption) {
        const variantSetSummaryIndex = getIndexOfVariantSetSummaryForVariantType(variantInfrastructure.variantSetSummaries, variantSetSummary.type);
        const preceedingVariantSetSummaries = variantInfrastructure.variantSetSummaries.slice(0, variantSetSummaryIndex);

        for (let i = 0; i < variantInfrastructure.variantCoefficientList.length; i++) {
            const variantCoefficient = variantInfrastructure.variantCoefficientList[i];

            const isolatedCoefficient = variantCoefficientHelperService.isolateVariantSetSummaryOptionCoefficientForVariant(variantSetSummary, preceedingVariantSetSummaries, variantCoefficient.coefficient);
            if (isolatedCoefficient == variantSetSummaryOption.optionCoefficient) {
                return true;
            }
        }

        return false;
    };

    const getNumberOfVariantsWithVariantSetOptionList = function(variantInfrastructure, variantSetSummaryOptionList) {
        if (variantSetSummaryOptionList == null || variantSetSummaryOptionList.length == 0) {
            return 0;
        }

        let count = 0;

        for (let i = 0; i < variantInfrastructure.variantCoefficientList.length; i++) {
            const variantCoefficient = variantInfrastructure.variantCoefficientList[i];
            let numberOfMatches = 0;

            for (let j = 0; j < variantSetSummaryOptionList.length; j++) {
                const variantSetSummaryOption = variantSetSummaryOptionList[j];
                const variantSetSummary = getVariantSetSummaryForVariantType(variantInfrastructure.variantSetSummaries, variantSetSummaryOption.optionType);
                const variantSetSummaryIndex = getIndexOfVariantSetSummaryForVariantType(variantInfrastructure.variantSetSummaries, variantSetSummaryOption.optionType);
                const preceedingVariantSetSummaries = variantInfrastructure.variantSetSummaries.slice(0, variantSetSummaryIndex);

                const isolatedCoefficient = variantCoefficientHelperService.isolateVariantSetSummaryOptionCoefficientForVariant(variantSetSummary, preceedingVariantSetSummaries, variantCoefficient.coefficient);
                if (isolatedCoefficient == variantSetSummaryOption.optionCoefficient) {
                    numberOfMatches++;
                } else {
                    break;
                }
            }

            if (numberOfMatches == variantSetSummaryOptionList.length) {
                count++;
            }
        }

        return count;
    };

    const getNumberOfVariantsWithVariantSetOption = function(variantInfrastructure, variantSetSummary, variantSetSummaryOption) {
        const variantSetSummaryIndex = getIndexOfVariantSetSummaryForVariantType(variantInfrastructure.variantSetSummaries, variantSetSummary.type);
        const preceedingVariantSetSummaries = variantInfrastructure.variantSetSummaries.slice(0, variantSetSummaryIndex);
        let count = 0;

        for (let i = 0; i < variantInfrastructure.variantCoefficientList.length; i++) {
            const variantCoefficient = variantInfrastructure.variantCoefficientList[i];

            const isolatedCoefficient = variantCoefficientHelperService.isolateVariantSetSummaryOptionCoefficientForVariant(variantSetSummary, preceedingVariantSetSummaries, variantCoefficient.coefficient);
            if (isolatedCoefficient == variantSetSummaryOption.optionCoefficient) {
                count++;
            }
        }

        return count;
    };

    const getIndexListOfVariantCoefficientsWithGivenNumberOfVariantDetails = function(variantCoefficientList, numberOfVariantDetails) {
        const variantCoefficientIndexList = [];

        angular.forEach(variantCoefficientList, (variantCoefficient, index) => {
            if (variantCoefficient.variant.variantDetails.length == numberOfVariantDetails) {
                variantCoefficientIndexList.push(index);
            }
        });

        return variantCoefficientIndexList;
    };

    const getNextAvailableOptionColour = function(coloursInUse) {
        for (let i = 0; i < variantSetOptionColours.length; i++) {
            const optionColour = variantSetOptionColours[i];
            let alreadyInUse = false;

            if (coloursInUse != null) {
                for (let j = 0; j < coloursInUse.length; j++) {
                    const colourInUse = coloursInUse[j];
                    if (colourInUse == optionColour) {
                        alreadyInUse = true;
                        break;
                    }
                }
            }

            if (!alreadyInUse) {
                return optionColour;
            }
        }

        return null;
    };

    const generateVariantSetId = function(variantSets) {
        let maxId = 0;

        angular.forEach(variantSets, (variantSet) => {
            if (variantSet.id > maxId) {
                maxId = variantSet.id;
            }
        });

        return maxId + 1;
    };

    const getNextSkuForSkuPattern = function(variantInfrastructure, skusInUse, skuPattern) {
        if (utils.hasNoValue(skuPattern)) {
            return null;
        }

        let variantSKU;
        let isUnique = false;
        let count = 1;

        while (!isUnique) {
            variantSKU = skuPattern + '-' + count;
            const lowerCaseSku = variantSKU.toLowerCase();

            let isSkuInUse = false;
            let isSkuOnAnotherVariant = false;

            if (skusInUse != null) {
                for (let i = 0; i < skusInUse.length; i++) {
                    if (lowerCaseSku == skusInUse[i].toLowerCase()) {
                        isSkuInUse = true;
                        break;
                    }
                }
            }

            if (!isSkuInUse) {
                for (let j = 0; j < variantInfrastructure.variantCoefficientList.length; j++) {
                    const variant = variantInfrastructure.variantCoefficientList[j].variant;

                    if (!utils.hasNoValue(variant.sku) && variant.sku.toLowerCase() == lowerCaseSku) {
                        isSkuOnAnotherVariant = true;
                        break;
                    }
                }
            }

            isUnique = (!isSkuInUse && !isSkuOnAnotherVariant);
            count++;
        }

        return variantSKU;
    };

    return {
        variantSetOptionExists(variantSetSummary, variantSetOptionValue) {
            return variantSetOptionExists(variantSetSummary, variantSetOptionValue);
        },

        variantExistsWithVariantSetOption(variantInfrastructure, variantSetSummary, variantSetSummaryOption) {
            return variantExistsWithVariantSetOption(variantInfrastructure, variantSetSummary, variantSetSummaryOption);
        },

        getNumberOfVariantsWithVariantSetOption(variantInfrastructure, variantSetSummary, variantSetSummaryOption) {
            return getNumberOfVariantsWithVariantSetOption(variantInfrastructure, variantSetSummary, variantSetSummaryOption);
        },

        getNumberOfVariantsWithVariantSetOptionList(variantInfrastructure, variantSetSummaryOptionList) {
            return getNumberOfVariantsWithVariantSetOptionList(variantInfrastructure, variantSetSummaryOptionList);
        },

        getVariantDetailForVariantType(variant, variantType) {
            return getVariantDetailForVariantType(variant, variantType);
        },

        getVariantSetSummaryForVariantType(variantSetSummaries, variantType) {
            return getVariantSetSummaryForVariantType(variantSetSummaries, variantType);
        },

        getIndexOfVariantSetSummaryForVariantType(variantSetSummaries, variantType) {
            return getIndexOfVariantSetSummaryForVariantType(variantSetSummaries, variantType);
        },

        getVariantSetSummaryOptionForOptionValue(variantSetSummary, optionValue) {
            return getVariantSetSummaryOptionForOptionValue(variantSetSummary, optionValue);
        },

        getIndexOfVariantSetSummaryOptionForOptionValue(variantSetSummary, optionValue) {
            return getIndexOfVariantSetSummaryOptionForOptionValue(variantSetSummary, optionValue);
        },

        getIndexListOfVariantCoefficientsWithGivenNumberOfVariantDetails(variantCoefficientList, numberOfVariantDetails) {
            return getIndexListOfVariantCoefficientsWithGivenNumberOfVariantDetails(variantCoefficientList, numberOfVariantDetails);
        },

        getVariantSetOptionColours() {
            return variantSetOptionColours;
        },

        getNextAvailableOptionColourForVariantSets(variantSets) {
            const coloursInUse = [];

            angular.forEach(variantSets, (variantSet) => {
                coloursInUse.push(variantSet.optionColour);
            });

            return getNextAvailableOptionColour(coloursInUse);
        },

        getNextAvailableOptionColourForVariantSetSummaries(variantSetSummaries) {
            const coloursInUse = [];

            angular.forEach(variantSetSummaries, (variantSetSummary) => {
                coloursInUse.push(variantSetSummary.optionColour);
            });

            return getNextAvailableOptionColour(coloursInUse);
        },

        generateVariantSetId(variantSets) {
            return generateVariantSetId(variantSets);
        },

        sortArrayDescending(anArrayOfValueTypes) {
            anArrayOfValueTypes.sort((a, b) => b - a);
        },

        getNextSkuForSkuPattern(variantInfrastructure, skusInUse, skuPattern) {
            return getNextSkuForSkuPattern(variantInfrastructure, skusInUse, skuPattern);
        }
    };
}]);



// WEBPACK FOOTER //
// ./src/inventory/services/variantHelper.services.js